import {
  Link as RouterLink,
  NavLink as RouterNavLink,
  useLocation,
  type LinkProps,
  type NavLinkProps,
} from "react-router-dom";
import { localizeTo } from "../i18n/localePath";

/** React Router's Link, with the current locale prefix added. */
export function Link({ to, ...props }: LinkProps) {
  const { pathname } = useLocation();
  return <RouterLink {...props} to={localizeTo(to, pathname)} />;
}

/** React Router's NavLink, with the current locale prefix added. */
export function NavLink({ to, ...props }: NavLinkProps) {
  const { pathname } = useLocation();
  return <RouterNavLink {...props} to={localizeTo(to, pathname)} />;
}
